module.exports = __webpack_public_path__ + "media/3-1.a2741d98.wav";